import type { UiLibrarySource } from "./ui-library-source";

export function uiLibrarySourceAttrs(source: UiLibrarySource) {
  if (!import.meta.env.DEV) return {};
  return { "data-ui-source": source };
}
